<template>

  <div id="app" class="sales-report-page">

    <yetkidialog ref="yetkidialog"></yetkidialog>

    <hatadialog ref="hatadialog"></hatadialog>

    <genelfiltre ref="genelfiltre"></genelfiltre>

    <v-app id="inspire" light>

      <v-card color="grey lighten-5" flat class="page-card">

        <v-layout row wrap>

          <v-flex xs12 md12 sm12>

            <v-toolbar dark color="info" class="page-toolbar">

              <v-toolbar-title>{{ $t('Sales-Report') }}</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-menu bottom left offset-y>

                <v-btn slot="activator" dark icon>

                  <v-icon>more_vert</v-icon>

                </v-btn>

                <v-list class="menu-list">

                  <v-list-tile v-if="PB === 'TRY'" @click="getListExcel()">

                    <v-list-tile-title>

                      Excel {{ $t('Download') }}

                    </v-list-tile-title>

                  </v-list-tile>

                  <v-list-tile v-if="PB === 'TRY'" @click="ExcelSatisRaporuPNR()">

                    <v-list-tile-title>

                      {{ $t('Excel-Sales-Report-PNR') }}

                    </v-list-tile-title>

                  </v-list-tile>

                  <v-list-tile @click="DownloadSatisRaporuCariKod(0, 'style')">

                    <v-list-tile-title>

                      Html {{ $t('Download') }} {{ $t('Group-by-Current-Code') }}

                    </v-list-tile-title>

                  </v-list-tile>

                  <v-list-tile @click="DownloadVizeSatisRaporuTakipNo(0, 'style')">

                    <v-list-tile-title>

                      Html {{ $t('Download') }} ( {{ $t('Visa-Sales-Report-According-Tracking-No') }} )

                    </v-list-tile-title>

                  </v-list-tile>

                  <v-list-tile v-if="PB === 'TRY'" @click="DownloadVizeSatisRaporu(1, 'style', '')">

                    <v-list-tile-title>

                      {{ $t('Excel-Visa-Sales-Report') }}

                    </v-list-tile-title>

                  </v-list-tile>

                  <v-list-tile v-if="PB === 'TRY'" @click="DownloadVizeSatisRaporu(1, 'style', 'MALIYET')">

                    <v-list-tile-title>

                      {{ $t('Excel-Visa-Sales-Report-Costs') }}

                    </v-list-tile-title>

                  </v-list-tile>

                  <v-list-tile v-if="PB === 'TRY'" @click="DownloadVizeSatisRaporu(1, 'style', 'SATIS')">

                    <v-list-tile-title>

                      {{ $t('Excel-Visa-Sales-Report-Sales') }}

                    </v-list-tile-title>

                  </v-list-tile>

                  <v-list-tile v-if="PB === 'TRY'" @click="DownloadKomisyonRaporu(1, 'style')">

                    <v-list-tile-title>

                      {{ $t('Excel-Commission-Report') }}

                    </v-list-tile-title>

                  </v-list-tile>

                  <v-list-tile @click="AcenteKomisyonRaporu()">

                    <v-list-tile-title>

                      {{ $t('Agency-Commission-Report') }}

                    </v-list-tile-title>

                  </v-list-tile>

                  <v-list-tile @click="AcenteKomisyonRaporuOzet()">

                    <v-list-tile-title>

                      {{ $t('Agency-Commission-Report-Summary') }}

                    </v-list-tile-title>

                  </v-list-tile>

                </v-list>

              </v-menu>

            </v-toolbar>

          </v-flex>

          <v-container fluid class="page-container">

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>

              <v-layout row wrap>

                <v-flex pb-3 xs12 sm12 md12>

                  <v-card flat class="filter-card">

                    <v-card-text class="pb-0">

                      <v-layout row wrap align-center>

                        <v-flex xs12 sm6 pt-2 md2>

                          <v-select

                            :label="$t('Date-Type')"

                            item-value="value"

                            item-text="text"

                            :items="itemstarihtip"

                            v-model="tarihTip"

                            solo

                            flat

                            hide-details

                          ></v-select>

                        </v-flex>

                        <v-flex xs12 sm6 pt-2 md2>

                          <tarihcomp

                            :etiket="$t('Starting-Date')"

                            :detaygizle="false"

                            :rules="dateRules"

                            :defaultvalue="'ok'"

                            :value="KayitTarihiBasla"

                            v-model="KayitTarihiBasla"

                          ></tarihcomp>

                        </v-flex>

                        <v-flex xs12 pt-2 sm6 md2>

                          <tarihcomp

                            :etiket="$t('Finishing-Date')"

                            :detaygizle="false"

                            :rules="dateRules"

                            :defaultvalue="'ok'"

                            :value="KayitTarihiBitis"

                            v-model="KayitTarihiBitis"

                          ></tarihcomp>

                        </v-flex>

                        <v-flex xs12 sm6 pt-2 md3>

                          <div class="report-mode-small-area">

                            <button

                              type="button"

                              class="report-mode-button"

                              :class="{ 'report-mode-button-active': ozetListe }"

                              @click="toggleOzetListe"

                            >

                              <v-icon v-if="ozetListe" small>check_circle</v-icon>

                              <v-icon v-else small>radio_button_unchecked</v-icon>

                              <span>{{ $t('Summary-List') }}</span>

                            </button>

                            <button

                              type="button"

                              class="report-mode-button"

                              :class="{ 'report-mode-button-active': pnrToplamRaporu }"

                              @click="togglePnrToplamRaporu"

                            >

                              <v-icon v-if="pnrToplamRaporu" small>check_circle</v-icon>

                              <v-icon v-else small>radio_button_unchecked</v-icon>

                              <span>{{ $t('PNR-Total') }}</span>

                            </button>

                          </div>

                        </v-flex>

                        <v-flex xs12 pt-2 md2>

                          <div class="filter-actions">

                            <div v-if="load1">

                              <v-btn

                                color="info"

                                @click="getList()"

                                fab

                                small

                                dark

                              >

                                <v-icon>search</v-icon>

                              </v-btn>

                            </div>

                            <div v-if="progress" class="progress-wrap">

                              <v-progress-circular

                                indeterminate

                                :width="4"

                                color="blue"

                                size="28"

                              ></v-progress-circular>

                            </div>

                            <v-tooltip bottom>

                              <v-btn

                                slot="activator"

                                small

                                @click="filtrele()"

                                color="info"

                                fab

                                dark

                              >

                                <v-icon>filter_list</v-icon>

                              </v-btn>

                              <span>{{ $t('Add-Search-Filter') }}</span>

                            </v-tooltip>

                            <v-chip

                              v-if="filtrevarmi"

                              small

                              color="green"

                              text-color="white"

                              class="filter-chip"

                            >

                              <v-icon left small>check_circle_outline</v-icon>

                              {{ $t('Filter') }}

                            </v-chip>

                          </div>

                        </v-flex>

                      </v-layout>

                      <!-- ÜST TOPLAM ALANI -->

                      <v-layout row wrap class="summary-cards-row">

                        <v-flex xs12 sm4 md4>

                          <div class="summary-card summary-sales">

                            <div class="summary-card-title">{{ $t('Total-Sales') }}</div>

                            <div class="summary-card-value">

                              {{ formatMoneyDisplay(toplamSatis) }}

                            </div>

                          </div>

                        </v-flex>

                        <v-flex xs12 sm4 md4>

                          <div class="summary-card summary-buying">

                            <div class="summary-card-title">{{ $t('Purchase-Total') }}</div>

                            <div class="summary-card-value">

                              {{ formatMoneyDisplay(toplamAlis) }}

                            </div>

                          </div>

                        </v-flex>

                        <v-flex xs12 sm4 md4>

                          <div class="summary-card summary-profit">

                            <div class="summary-card-title">{{ $t('Total-Gain') }}</div>

                            <div class="summary-card-value">

                              {{ formatMoneyDisplay(toplamKar) }}

                            </div>

                          </div>

                        </v-flex>

                      </v-layout>

                    </v-card-text>

                  </v-card>

                </v-flex>

                <v-flex xs12 sm12 md12 pb-1>

                  <ReportTable

                    :headers="headers"

                    :items="itemssatis"

                    :loading="progress"

                    :has-searched="hasSearched"

                    :storage-key="reportTableStorageKey"

                    :search-label="$t('Search')"

                    :show-frontend-export="true"

                    :rows-per-page-items="[20, 100]"

                    :excel-summary-config="excelSummaryConfig"

                    class="report-table-host"

                  >

                    <template slot="cell" slot-scope="slotProps">

                      <div

                        class="cell-click-area"

                        @click="onCellClick(slotProps.item, slotProps.column)"

                      >

                        {{ slotProps.value }}

                      </div>

                    </template>

                  </ReportTable>

                </v-flex>

                <!-- ALT TOPLAM ALANI -->

                <v-flex xs12 sm12 md12 pb-3>

                  <div class="bottom-summary-bar">

                    <div class="bottom-summary-item">

                      <span class="bottom-summary-label">{{ $t('PNR-Total') }}:</span>

                      <strong class="bottom-summary-value">

                        {{ toplamPnr }}

                      </strong>

                    </div>

                    <div class="bottom-summary-item">

                      <span class="bottom-summary-label">{{ $t('Total-Passengers') }}:</span>

                      <strong class="bottom-summary-value">

                        {{ toplamYolcu }}

                      </strong>

                    </div>

                    <div class="bottom-summary-item">

                      <span class="bottom-summary-label">{{ $t('Total-Sales') }}:</span>

                      <strong class="bottom-summary-value">

                        {{ formatMoneyDisplay(toplamSatis) }}

                      </strong>

                    </div>

                    <div class="bottom-summary-item">

                      <span class="bottom-summary-label">{{ $t('Purchase-Total') }}:</span>

                      <strong class="bottom-summary-value">

                        {{ formatMoneyDisplay(toplamAlis) }}

                      </strong>

                    </div>

                    <div class="bottom-summary-item">

                      <span class="bottom-summary-label">{{ $t('Total-Gain') }}:</span>

                      <strong class="bottom-summary-value">

                        {{ formatMoneyDisplay(toplamKar) }}

                      </strong>

                    </div>

                  </div>

                </v-flex>

              </v-layout>

            </v-form>

          </v-container>

          <v-snackbar

            :timeout="timeout"

            :top="y === 'top'"

            :bottom="y === 'bottom'"

            :right="x === 'right'"

            :left="x === 'left'"

            :multi-line="mode === 'multi-line'"

            :vertical="mode === 'vertical'"

            v-model="snackbar"

          >

            {{ text1 }}

            <v-btn flat color="pink" @click="snackbar = false">

              {{ $t('Close') }}

            </v-btn>

          </v-snackbar>

        </v-layout>

      </v-card>

    </v-app>

  </div>

</template>

<script>

import tarihcomp from "../../customcomp/tarihim";

import helpers from "@/components/app/customcomp/helpers.js";

import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";

import tool from "../../coper/tools";

import hatadialog from "@/components/app/coper/comp/hatadialog.vue";

import genelfiltre from "../comp/genelfiltre.vue";

import ReportTable from "@/components/app/customcomp/ReportTable.vue";

function createHeaders(vm) {

  return [

    { text: "PNR", value: "PNR_No", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },

    { text: vm.$t("PNR-Reservation-Code"), value: "PNR_RezzKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" },

    { text: vm.$t("Tour-Code"), value: "PNR_TurKodu", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },

    { text: vm.$t("Date"), value: "KayitTarihi", type: "date", align: "left", visible: true, sortable: true, minWidth: "140px" },

    { text: vm.$t("Currentcode_label"), value: "PNR_CariKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" },

    { text: vm.$t("Sales"), value: "SatisTutar", type: "money", align: "left", visible: true, sortable: true, minWidth: "130px" },

    { text: vm.$t("Buying"), value: "AlisTutar", type: "money", align: "left", visible: true, sortable: true, minWidth: "130px" },

    { text: vm.$t("Commission"), value: "PKomisyonTutar", type: "money", align: "left", visible: true, sortable: true, minWidth: "150px" },

    { text: vm.$t("Payment"), value: "Odeme", type: "money", align: "right", visible: true, sortable: true, minWidth: "130px" },

    { text: vm.$t("Balance"), value: "Bakiye", type: "money", align: "right", visible: true, sortable: true, minWidth: "130px" },

    { text: vm.$t("Commission"), value: "KomisyonTL", type: "money", align: "right", visible: true, sortable: true, minWidth: "140px" },

    { text: vm.$t("Profit"), value: "PNR_Kar", type: "money", align: "right", visible: true, sortable: true, minWidth: "130px" },

    { text: vm.$t("Title_label"), value: "CariUnvan", type: "text", align: "left", visible: true, sortable: true, minWidth: "220px" },

    { text: vm.$t("Company-No"), value: "SirketNo", type: "text", align: "left", visible: true, sortable: true, minWidth: "120px" },

    { text: vm.$t("Sales"), value: "PNR_SatisTL", type: "money", align: "left", visible: true, sortable: true, minWidth: "130px" },

    { text: vm.$t("Buying"), value: "PNR_AlisTL", type: "money", align: "left", visible: true, sortable: true, minWidth: "130px" },

    { text: vm.$t("Commission"), value: "PNR_KomisyonTL", type: "money", align: "left", visible: true, sortable: true, minWidth: "150px" },

    { text: vm.$t("First-Entry"), value: "Donem1", type: "date", align: "left", visible: true, sortable: true, minWidth: "140px" },

    { text: vm.$t("Last-Departure"), value: "Donem2", type: "date", align: "left", visible: true, sortable: true, minWidth: "150px" },

    { text: vm.$t("Profit"), value: "PNR_KarTL", type: "money", align: "left", visible: true, sortable: true, minWidth: "130px" },

    { text: vm.$t("Seller"), value: "SaticiCariUnvan", type: "text", align: "left", visible: true, sortable: true, minWidth: "220px" },

    { text: vm.$t("Booker"), value: "RezYapan", type: "text", align: "left", visible: true, sortable: true, minWidth: "170px" },

    { text: vm.$t("Name"), value: "KisiIsimList", type: "text", align: "left", visible: true, sortable: true, minWidth: "230px" },

    { text: vm.$t("Main-Type"), value: "AnaTip", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" },

    { text: vm.$t("Agency"), value: "Acente", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" },

    { text: vm.$t("Country_label"), value: "PNRUlke", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" }

  ];

}

function createPnrToplamHeaders(vm) {

  return [

    { text: "PNR", value: "PNR_No", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },

    { text: vm.$t("Tour-Code"), value: "PNR_TurKodu", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },

    { text: vm.$t("Purchase-Total"), value: "ToplamAlis", type: "money", align: "right", visible: true, sortable: true, minWidth: "170px" },

    { text: vm.$t("Total-Sales"), value: "ToplamSatis", type: "money", align: "right", visible: true, sortable: true, minWidth: "170px" },

    { text: vm.$t("Total-Gain"), value: "ToplamKar", type: "money", align: "right", visible: true, sortable: true, minWidth: "170px" },

    { text: vm.$t("Total-Passengers"), value: "ToplamYolcu", type: "text", align: "right", visible: true, sortable: true, minWidth: "160px" }

  ];

}

function beforeMount() {}

export default {

  name: "SatisRaporu",

  beforeMount,

  components: {

    tarihcomp,

    yetkidialog,

    hatadialog,

    genelfiltre,

    ReportTable

  },

  filters: {

    dateformat(t) {

      return helpers.dateformat(t);

    },

    moneyformat(m) {

      return helpers.moneyformat(m);

    },

    bakiyekontrol(m) {

      return helpers.bakiyekontrol(m);

    }

  },

  data() {

    return {

      headers: [],

      hasSearched: false,

      PB: "TRY",

      itemstarihtip: genelfiltre.IslemTarihTip(),

      tarihTip: 0,

      sayfayetki: {

        Screen: false,

        Update: false,

        Save: false,

        Delete: false,

        Status: false,

        Message: null,

        islem: 0

      },

      filtrevarmi: false,

      searchsatilanbilet: null,

      headerssatis: [],

      Rapor: genelfiltre.EmptyPrametre(),

      KayitTarihiBasla: null,

      KayitTarihiBitis: null,

      valid: true,

      date: null,

      menu: false,

      modal: false,

      loading: false,

      items: [],

      load: false,

      load1: true,

      progress: false,

      itemssatis: [],

      butondurum: true,

      snackbar: false,

      y: "top",

      x: "right",

      mode: "",

      timeout: 6000,

      text1: "",

      ozetListe: false,

      pnrToplamRaporu: false,

      excelSummaryConfig: {

        label: this.$t("Grand-Total"),

        fields: [

          { key: "SatisTutar", type: "money" },

          { key: "AlisTutar", type: "money" },

          { key: "PNR_Kar", type: "money" }

        ]

      },

      dictionary: {

        custom: {

          tarihsec: {

            required: () => this.$t("Please-select-a-date")

          },

          tarihsec1: {

            required: () => this.$t("Please-select-a-date")

          }

        }

      }

    };

  },

  computed: {

    dateRules() {

      return [(v) => !!v || this.$t("Please-select-a-date")];

    },

    aktifRaporTipi() {

      if (this.pnrToplamRaporu === true) {

        return "pnrToplam";

      }

      if (this.ozetListe === true) {

        return "ozetListe";

      }

      return "normal";

    },

    reportTableStorageKey() {

  if (this.aktifRaporTipi === "pnrToplam") {

    return "satisraporu_report_table_pnr_toplam_v2";

  }

  if (this.aktifRaporTipi === "ozetListe") {

    return "satisraporu_report_table_ozet_liste_v2";

  }

  return "satisraporu_report_table_v2";

},

    toplamPnr() {

      if (!Array.isArray(this.itemssatis) || !this.itemssatis.length) {

        return 0;

      }

      if (this.aktifRaporTipi === "pnrToplam") {

        return this.itemssatis.length;

      }

      const pnrList = {};

      this.itemssatis.forEach((item) => {

        if (item && item.PNR_No) {

          pnrList[item.PNR_No] = true;

        }

      });

      return Object.keys(pnrList).length;

    },

    toplamYolcu() {

      if (!Array.isArray(this.itemssatis) || !this.itemssatis.length) {

        return 0;

      }

      if (this.aktifRaporTipi === "pnrToplam") {

        return this.sumField("ToplamYolcu");

      }

      const pnrMap = {};

      this.itemssatis.forEach((item) => {

        if (!item || !item.PNR_No) {

          return;

        }

        const pnr = item.PNR_No;

        const kisiSayisi = this.getRawNumberValue(item.PNR_KisiSayisi);

        const pax = this.getRawNumberValue(item.Pax);

        const inf = this.getRawNumberValue(item.INF);

        const yolcu = kisiSayisi > 0 ? kisiSayisi : pax + inf;

        if (!pnrMap[pnr] || yolcu > pnrMap[pnr]) {

          pnrMap[pnr] = yolcu;

        }

      });

      return Object.keys(pnrMap).reduce((total, pnr) => {

        return total + this.getRawNumberValue(pnrMap[pnr]);

      }, 0);

    },

    toplamSatis() {

      if (this.aktifRaporTipi === "pnrToplam") {

        return this.sumField("ToplamSatis");

      }

      return this.sumField("SatisTutar");

    },

    toplamAlis() {

      if (this.aktifRaporTipi === "pnrToplam") {

        return this.sumField("ToplamAlis");

      }

      return this.sumField("AlisTutar");

    },

    toplamKar() {

      if (this.aktifRaporTipi === "pnrToplam") {

        return this.sumField("ToplamKar");

      }

      return this.sumField("PNR_Kar");

    }

  },

  beforeRouteEnter(to, from, next) {

    next((vm) => {

      vm.prevRoute = from.path;

    });

  },

  mounted() {

    this.applyReportMode();

    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    const credentialsRaw = window.localStorage.getItem("credentials");

    if (credentialsRaw) {

      try {

        const credentials = JSON.parse(credentialsRaw);

        if (credentials && credentials.ParaBirimi) {

          this.PB = credentials.ParaBirimi;

        }

      } catch (error) {

        this.PB = "TRY";

      }

    }

    if (this.sayfayetki.Status !== true) {

      this.$refs.yetkidialog

        .open(this.sayfayetki.Message, this.sayfayetki.islem)

        .then((sonuc) => {

          if (sonuc === true) {

            if (this.$validator && this.$validator.localize) {

              this.$validator.localize("en", this.dictionary);

            }

            if (this.prevRoute != null) {

              window.open("#" + this.prevRoute, "_self");

            } else {

              window.open("#/", "_self");

            }

          }

        })

        .catch(() => {});

    }

  },

  methods: {

    toggleOzetListe() {

      this.ozetListe = !this.ozetListe;

      if (this.ozetListe === true) {

        this.pnrToplamRaporu = false;

      }

      this.applyReportMode();

      this.clearReportDataAfterModeChange();

    },

    togglePnrToplamRaporu() {

      this.pnrToplamRaporu = !this.pnrToplamRaporu;

      if (this.pnrToplamRaporu === true) {

        this.ozetListe = false;

      }

      this.applyReportMode();

      this.clearReportDataAfterModeChange();

    },

    clearReportDataAfterModeChange() {

      this.itemssatis = [];

      this.hasSearched = false;

    },

    applyReportMode() {

      if (this.aktifRaporTipi === "pnrToplam") {

        this.headers = createPnrToplamHeaders(this);

        this.excelSummaryConfig = {

          label: this.$t("PNR-Total"),

          fields: [

            { key: "ToplamAlis", type: "money" },

            { key: "ToplamSatis", type: "money" },

            { key: "ToplamKar", type: "money" }

          ]

        };

        return;

      }

      this.headers = createHeaders(this);

      this.excelSummaryConfig = {

        label: this.aktifRaporTipi === "ozetListe" ? this.$t("Summary-Total") : this.$t("Grand-Total"),

        fields: [

          { key: "SatisTutar", type: "money" },

          { key: "AlisTutar", type: "money" },

          { key: "PNR_Kar", type: "money" }

        ]

      };

    },

    onCellClick(item) {

      if (!item || !item.PNR_No) {

        return;

      }

      this.git(item);

    },

    HataYonetimi(response, request, baslik) {

      if (response && response.status === 500) {

        this.$refs.hatadialog.open(response, request, baslik);

      } else {

        this.text1 = "Service Unavailable - " + baslik;

        this.snackbar = true;

      }

    },

    git(val) {

      const url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;

      window.open(url, "_target");

    },

    filtrele() {

      this.$refs.genelfiltre

        .open("")

        .then((confirm) => {

          if (confirm.Status === true) {

            this.filtrevarmi = true;

            this.Rapor = confirm.Rapor;

            this.getList();

          } else {

            this.filtrevarmi = false;

            this.Rapor = confirm.Rapor;

          }

        })

        .catch(() => {});

    },

    validateDateRange() {

      if (!this.$refs.formgunluksatis.validate()) {

        return false;

      }

      const bastarih = new Date(this.KayitTarihiBasla);

      const bittarih = new Date(this.KayitTarihiBitis);

      if (bastarih <= bittarih) {

        return true;

      }

      this.text1 = this.$t("start-date-cannot-greater-than-end-date");

      this.snackbar = true;

      return false;

    },

    createReportParams() {

      return {

        prm: genelfiltre.ParametreOlustur(

          genelfiltre.RaporTarihAyarla(

            this.Rapor,

            this.tarihTip,

            this.KayitTarihiBasla,

            this.KayitTarihiBitis

          )

        ),

        tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),

        sayfaAdi: this.$route.name,

        // Eski özet liste mantığı aynen korunuyor.

        ozetListe: this.ozetListe === true,

        // Yeni seçim bilgisi.

        raporGorunum: this.aktifRaporTipi

      };

    },

    getRawNumberValue(value) {

      if (value === null || value === undefined || value === "") {

        return 0;

      }

      if (typeof value === "number") {

        return isNaN(value) ? 0 : value;

      }

      const normalized = String(value)

        .replace(/\s/g, "")

        .replace(/\./g, "")

        .replace(/,/g, ".");

      const parsed = parseFloat(normalized);

      return isNaN(parsed) ? 0 : parsed;

    },

    sumField(fieldName) {

      if (!Array.isArray(this.itemssatis) || !this.itemssatis.length) {

        return 0;

      }

      return this.itemssatis.reduce((total, item) => {

        return total + this.getRawNumberValue(item[fieldName]);

      }, 0);

    },

    formatMoneyDisplay(value) {

      return helpers.moneyformat(value || 0);

    },

    getList() {

      if (!this.validateDateRange()) {

        return;

      }

      this.applyReportMode();

      this.hasSearched = true;

      this.progress = true;

      this.load1 = false;

      const params = this.createReportParams();

      tool.http_post(this, "SatisRaporu", params)

        .then((response) => {

          if (response.body.Status === true) {

            if (this.aktifRaporTipi === "pnrToplam") {

              this.itemssatis = response.body.PnrToplamlar || [];

            } else {

              this.itemssatis = response.body.data || [];

            }

          } else {

            this.itemssatis = [];

            this.text1 = response.body.ErrorList[0];

            this.snackbar = true;

          }

        })

        .catch((response) => {

          this.itemssatis = [];

          this.HataYonetimi(response, params, this.$t("Sales-List-Could-Not-Be-Retrieved"));

        })

        .then(() => {

          this.progress = false;

          this.load1 = true;

        });

    },

    getListExcel() {

      if (!this.validateDateRange()) {

        return;

      }

      this.progress = true;

      this.load1 = false;

      const params = this.createReportParams();

      tool.api_post_FileDownload(this, "Coper/ExcelSatisRaporu", params)

        .then((response) => {

          tool.CreateDownloadLink(response, "CoperSatisRaporu.xlsx");

        })

        .catch((response) => {

          this.HataYonetimi(response, params, this.$t("Sales-List-Could-Not-Be-Retrieved"));

        })

        .then(() => {

          this.progress = false;

          this.load1 = true;

        });

    },

    ExcelSatisRaporuPNR() {

      if (!this.validateDateRange()) {

        return;

      }

      this.progress = true;

      this.load1 = false;

      const params = this.createReportParams();

      tool.api_post_FileDownload(this, "Coper/ExcelSatisRaporuPNR", params)

        .then((response) => {

          tool.CreateDownloadLink(response, "CoperSatisRaporuPNR.xlsx");

        })

        .catch((response) => {

          this.HataYonetimi(response, params, this.$t("Sales-List-Could-Not-Be-Retrieved"));

        })

        .then(() => {

          this.progress = false;

          this.load1 = true;

        });

    },

    AcenteKomisyonRaporu() {

      if (!this.validateDateRange()) {

        return;

      }

      this.progress = true;

      this.load1 = false;

      const params = {

        tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),

        sayfaAdi: this.$route.name

      };

      tool.api_post_FileDownload(this, "Coper/ExcelAcenteKomisyonRapor", params)

        .then((response) => {

          tool.CreateDownloadLink(response, "AcenteKomisyonRaporu.xlsx");

        })

        .catch((response) => {

          this.HataYonetimi(response, params, this.$t("Report-Could-Not-Be-Retrieved"));

        })

        .then(() => {

          this.progress = false;

          this.load1 = true;

        });

    },

    AcenteKomisyonRaporuOzet() {

      if (!this.validateDateRange()) {

        return;

      }

      this.progress = true;

      this.load1 = false;

      const params = {

        tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),

        sayfaAdi: this.$route.name

      };

      tool.api_post_FileDownload(this, "Coper/ExcelAcenteKomisyonRaporOzet", params)

        .then((response) => {

          tool.CreateDownloadLink(response, "AcenteKomisyonRaporuOzet.xlsx");

        })

        .catch((response) => {

          this.HataYonetimi(response, params, this.$t("Report-Could-Not-Be-Retrieved"));

        })

        .then(() => {

          this.progress = false;

          this.load1 = true;

        });

    },

    DownloadVizeSatisRaporuTakipNo(RaporTip, styleFile) {

      if (!this.validateDateRange()) {

        return;

      }

      this.progress = true;

      this.load1 = false;

      const params = {

        data: {

          Prm: genelfiltre.ParametreOlustur(

            genelfiltre.RaporTarihAyarla(

              this.Rapor,

              this.tarihTip,

              this.KayitTarihiBasla,

              this.KayitTarihiBitis

            )

          )

        },

        raporTipi: RaporTip,

        styleFile: styleFile,

        tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),

        sayfaAdi: this.$route.name

      };

      tool.api_post_FileDownload(this, "Coper/DownloadVizeSatisRaporuTakipNo", params)

        .then((response) => {

          if (RaporTip === 0) {

            tool.CreateDownloadLink(response, "VizeSatisRaporuTakipNo.html");

          } else if (RaporTip === 1) {

            tool.CreateDownloadLink(response, "VizeSatisRaporuTakipNo.xls");

          }

        })

        .catch((response) => {

          this.HataYonetimi(response, params, this.$t("Sales-List-Could-Not-Be-Retrieved"));

        })

        .then(() => {

          this.progress = false;

          this.load1 = true;

        });

    },

    DownloadKomisyonRaporu(RaporTip, styleFile) {

      if (!this.validateDateRange()) {

        return;

      }

      this.progress = true;

      this.load1 = false;

      const params = {

        data: {

          Prm: genelfiltre.ParametreOlustur(

            genelfiltre.RaporTarihAyarla(

              this.Rapor,

              this.tarihTip,

              this.KayitTarihiBasla,

              this.KayitTarihiBitis

            )

          )

        },

        raporTipi: RaporTip,

        styleFile: styleFile,

        tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),

        sayfaAdi: this.$route.name

      };

      tool.api_post_FileDownload(this, "Coper/DownloadKomisyonRaporu", params)

        .then((response) => {

          if (RaporTip === 0) {

            tool.CreateDownloadLink(response, "KomisyonRaporu.html");

          } else if (RaporTip === 1) {

            tool.CreateDownloadLink(response, "KomisyonRaporu.xls");

          }

        })

        .catch((response) => {

          this.HataYonetimi(response, params, this.$t("Sales-List-Could-Not-Be-Retrieved"));

        })

        .then(() => {

          this.progress = false;

          this.load1 = true;

        });

    },

    DownloadVizeSatisRaporu(RaporTip, styleFile, sablonAdi) {

      if (!this.validateDateRange()) {

        return;

      }

      this.progress = true;

      this.load1 = false;

      const params = {

        data: {

          Prm: genelfiltre.ParametreOlustur(

            genelfiltre.RaporTarihAyarla(

              this.Rapor,

              this.tarihTip,

              this.KayitTarihiBasla,

              this.KayitTarihiBitis

            )

          )

        },

        raporTipi: RaporTip,

        styleFile: styleFile,

        sablonAdi: sablonAdi,

        tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),

        sayfaAdi: this.$route.name

      };

      tool.api_post_FileDownload(this, "Coper/DownloadVizeSatisRaporu", params)

        .then((response) => {

          if (RaporTip === 0) {

            tool.CreateDownloadLink(response, "VizeSatisRaporu.html");

          } else if (RaporTip === 1) {

            tool.CreateDownloadLink(response, "VizeSatisRaporu.xls");

          }

        })

        .catch((response) => {

          this.HataYonetimi(response, params, this.$t("Sales-List-Could-Not-Be-Retrieved"));

        })

        .then(() => {

          this.progress = false;

          this.load1 = true;

        });

    },

    DownloadSatisRaporuCariKod(RaporTip, styleFile) {

      if (!this.validateDateRange()) {

        return;

      }

      this.progress = true;

      this.load1 = false;

      const params = {

        data: {

          Prm: genelfiltre.ParametreOlustur(

            genelfiltre.RaporTarihAyarla(

              this.Rapor,

              this.tarihTip,

              this.KayitTarihiBasla,

              this.KayitTarihiBitis

            )

          )

        },

        tumSirketler: this.$refs.genelfiltre.TumSirketlerParametre(),

        sayfaAdi: this.$route.name,

        raporTipi: RaporTip,

        styleFile: styleFile

      };

      tool.api_post_FileDownload(this, "Coper/DownloadSatisRaporuCariKod", params)

        .then((response) => {

          if (RaporTip === 0) {

            tool.CreateDownloadLink(response, "CoperSatisRaporu.html");

          } else if (RaporTip === 1) {

            tool.CreateDownloadLink(response, "CoperSatisRaporu.xls");

          }

        })

        .catch((response) => {

          this.HataYonetimi(response, params, this.$t("Sales-List-Could-Not-Be-Retrieved"));

        })

        .then(() => {

          this.progress = false;

          this.load1 = true;

        });

    }

  }

};

</script>

<style scoped>

.sales-report-page {

  min-height: 100vh;

  background: #f1f3f5;

}

.page-card {

  min-height: 100vh;

}

.page-toolbar {

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);

}

.page-container {

  padding-top: 22px;

}

.filter-card {

  background: #ffffff;

  border-radius: 4px;

}

.filter-actions {

  min-height: 48px;

  display: flex;

  align-items: center;

  justify-content: flex-end;

  flex-wrap: wrap;

  gap: 10px;

}

.progress-wrap {

  display: inline-flex;

  align-items: center;

  justify-content: center;

}

.filter-chip {

  margin-left: 0;

}

.summary-toggle-wrap {

  min-height: 48px;

  display: flex;

  align-items: center;

}

.report-mode-small-area {

  min-height: 48px;

  display: flex;

  align-items: center;

  justify-content: flex-start;

  flex-wrap: wrap;

  gap: 8px;

}

.report-mode-button {

  height: 34px;

  padding: 0 12px;

  border-radius: 18px;

  border: 1px solid #d0d7de;

  background: #ffffff;

  color: #455a64;

  font-size: 12px;

  font-weight: 600;

  display: inline-flex;

  align-items: center;

  gap: 6px;

  cursor: pointer;

  outline: none;

  transition: 0.18s ease;

  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.05);

}

.report-mode-button:hover {

  border-color: #2196f3;

  color: #1976d2;

  box-shadow: 0 5px 14px rgba(33, 150, 243, 0.12);

}

.report-mode-button .v-icon {

  color: #90a4ae;

}

.report-mode-button-active {

  border-color: #2196f3;

  background: #e3f2fd;

  color: #1565c0;

}

.report-mode-button-active .v-icon {

  color: #1976d2;

}

.summary-cards-row {

  margin-top: 18px;

  margin-bottom: 4px;

}

.summary-card {

  background: #ffffff;

  border: 1px solid #e2e8f0;

  border-radius: 12px;

  padding: 16px;

  min-height: 90px;

  display: flex;

  flex-direction: column;

  justify-content: center;

  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.05);

}

.summary-card-title {

  font-size: 13px;

  color: #607d8b;

  margin-bottom: 8px;

  font-weight: 600;

}

.summary-card-value {

  font-size: 24px;

  font-weight: 700;

  color: #263238;

  line-height: 1.2;

  word-break: break-word;

}

.summary-sales {

  border-top: 4px solid #2196f3;

}

.summary-buying {

  border-top: 4px solid #ff9800;

}

.summary-profit {

  border-top: 4px solid #4caf50;

}

.report-table-host {

  width: 100%;

}

.bottom-summary-bar {

  width: 100%;

  display: flex;

  justify-content: flex-end;

  align-items: center;

  flex-wrap: wrap;

  gap: 24px;

  padding: 14px 8px 2px 8px;

}

.bottom-summary-item {

  display: flex;

  align-items: center;

  gap: 8px;

}

.bottom-summary-label {

  font-size: 14px;

  color: #607d8b;

  font-weight: 600;

}

.bottom-summary-value {

  font-size: 16px;

  color: #263238;

}

.cell-click-area {

  display: block;

  width: 100%;

  min-height: 24px;

  cursor: pointer;

}

.menu-list {

  min-width: 340px;

}

@media (max-width: 960px) {

  .filter-actions {

    justify-content: flex-start;

  }

  .summary-cards-row {

    margin-top: 14px;

  }

  .bottom-summary-bar {

    justify-content: flex-start;

    gap: 14px;

  }

  .bottom-summary-item {

    width: 100%;

  }

}

</style>